import ChapterNumberTag from "./ChapterNumberTag";

export default ChapterNumberTag;
